import React, { Component } from "react";
import {
  Wrapper,
  Copy,
  Bold,
  Row,
  SwitchButton
} from "app/NativeComponents/common";
import { store } from "app/store";

class FrequencySwitch extends Component {
  render() {
    const colors = store.getState().settings.colors;
    const device = store.getState().native.device;

    return (
      <Wrapper
        style={{
          alignItems: "center",
          justifyContent: "center",
          padding: 10,
          paddingBottom: 20
        }}
      >
        <Row>
          <Wrapper style={{ width: 110, alignItems: "flex-end" }}>
            <Copy
              style={{
                fontWeight:
                  this.props.selected_frequency !== "annually"
                    ? "bold"
                    : "normal"
              }}
            >
              Monthly
            </Copy>
          </Wrapper>
          <Wrapper style={{ margin: 10, marginBottom: 0, marginTop: 0 }}>
            <SwitchButton
              style={{}}
              value={this.props.selected_frequency == "annually" ? true : false}
              onChange={value => {
                if (device == "mobile") {
                  this.props.onPress(value ? "annually" : "monthly");
                } else {
                  this.props.onPress(!value ? "annually" : "monthly");
                }
              }}
            />
          </Wrapper>
          <Wrapper style={{ width: 110, alignItems: "flex-start" }}>
            <Row>
              <Copy
                style={{
                  fontWeight:
                    this.props.selected_frequency === "annually"
                      ? "bold"
                      : "normal"
                }}
              >
                Annual
              </Copy>
              <Copy
                style={{
                  fontSize: 10,
                  marginLeft: 5,
                  color: colors.light_text_color
                }}
              >
                SAVE 17%
              </Copy>
            </Row>
          </Wrapper>
        </Row>
      </Wrapper>
    );
  }
}

export default FrequencySwitch;
